import { FunctionComponent, useEffect, useState } from 'react'
import styles from './cron.module.scss'
import Title from '@/components/_custom/Title/title'
import { useTranslation } from 'react-i18next'
import { Cron } from '@/types/Cron'
import { useQuery } from '@apollo/client'
import { GET_CRON } from '@/modules/API/software/cronHandler'
import Loading from '@/components/Loading/Loading'
import CronLine from './cronLine'

const CronSettings: FunctionComponent = () => {
    const { t } = useTranslation()

    const [cronList, setCronList] = useState<Array<Cron>>([])
    const { loading: loadingCron, data: dataCron } = useQuery(GET_CRON)

    useEffect(() => {
        if (dataCron) {
            setCronList(dataCron.getCron)
        }
    }, [dataCron])

    return (
        <div className={styles.Container}>
            <Title text={t('cron')} className={styles.Title} />
            {loadingCron && <Loading overall={false} />}
            {dataCron && (
                <div className={styles.CronPlacement}>
                    {cronList.length === 0 ? (
                        <div className={styles.TextContainer}>{t('noCron')}</div>
                    ) : (
                        cronList.map((cron: Cron, index: number) => (
                            <CronLine
                                key={index}
                                purpose={cron.purpose}
                                minute={cron.minute}
                                hour={cron.hour}
                                day={cron.day}
                                month={cron.month}
                            />
                        ))
                    )}
                </div>
            )}
        </div>
    )
}

export default CronSettings
